/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as DefinirSenhaRouteImport } from './routes/definir-senha'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAgendaRouteImport } from './routes/app/agenda'
import { Route as AppCampanhasRouteImport } from './routes/app/campanhas'
import { Route as AppClinicaRouteImport } from './routes/app/clinica'
import { Route as AppComunicacaoRouteImport } from './routes/app/comunicacao'
import { Route as AppDossieRouteImport } from './routes/app/dossie'
import { Route as AppEstoqueRouteImport } from './routes/app/estoque'
import { Route as AppFunilRouteImport } from './routes/app/funil'
import { Route as AppInicioRouteImport } from './routes/app/inicio'
import { Route as AppMetricasRouteImport } from './routes/app/metricas'
import { Route as AppMinhasFinancasRouteImport } from './routes/app/minhas-financas'
import { Route as AppMuralRouteImport } from './routes/app/mural'
import { Route as AppRadarRouteImport } from './routes/app/radar'
import { Route as AppRetornosRouteImport } from './routes/app/retornos'
import { Route as AppSenhaRouteImport } from './routes/app/senha'
import { Route as AppSolicitacoesRouteImport } from './routes/app/solicitacoes'
import { Route as ConfirmarTokenRouteImport } from './routes/confirmar/$token'
import { Route as AppAtendimentoIndexRouteImport } from './routes/app/atendimento/index'
import { Route as AppAtendimentoPacienteIdRouteImport } from './routes/app/atendimento/$pacienteId'
import { Route as AppCirurgiasIndexRouteImport } from './routes/app/cirurgias/index'
import { Route as AppCirurgiasDitadoRouteImport } from './routes/app/cirurgias/ditado'
import { Route as AppCirurgiasPrecosRouteImport } from './routes/app/cirurgias/precos'
import { Route as AppDevSwitchRouteImport } from './routes/app/dev/switch'
import { Route as AppFinanceiroIndexRouteImport } from './routes/app/financeiro/index'
import { Route as AppFinanceiroDmedRouteImport } from './routes/app/financeiro/dmed'
import { Route as AppFinanceiroExportarRouteImport } from './routes/app/financeiro/exportar'
import { Route as AppFinanceiroFechamentoRouteImport } from './routes/app/financeiro/fechamento'
import { Route as AppFinanceiroNotasFiscaisRouteImport } from './routes/app/financeiro/notas-fiscais'
import { Route as AppOrcamentosIndexRouteImport } from './routes/app/orcamentos/index'
import { Route as AppOrcamentosIdRouteImport } from './routes/app/orcamentos/$id'
import { Route as AppPacientesIndexRouteImport } from './routes/app/pacientes/index'
import { Route as AppAtendimentoAtestadoIdRouteImport } from './routes/app/atendimento/atestado/$id'
import { Route as AppAtendimentoExameIdRouteImport } from './routes/app/atendimento/exame/$id'
import { Route as AppAtendimentoReceitaIdRouteImport } from './routes/app/atendimento/receita/$id'
import { Route as AppFinanceiroReciboIdRouteImport } from './routes/app/financeiro/recibo/$id'
import { Route as AppPacientesIdIndexRouteImport } from './routes/app/pacientes/$id/index'
import { Route as AppPacientesIdExportarRouteImport } from './routes/app/pacientes/$id/exportar'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const DefinirSenhaRoute = DefinirSenhaRouteImport.update({
  id: '/definir-senha',
  path: '/definir-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendaRoute = AppAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AppRoute,
} as any)
const AppCampanhasRoute = AppCampanhasRouteImport.update({
  id: '/campanhas',
  path: '/campanhas',
  getParentRoute: () => AppRoute,
} as any)
const AppClinicaRoute = AppClinicaRouteImport.update({
  id: '/clinica',
  path: '/clinica',
  getParentRoute: () => AppRoute,
} as any)
const AppComunicacaoRoute = AppComunicacaoRouteImport.update({
  id: '/comunicacao',
  path: '/comunicacao',
  getParentRoute: () => AppRoute,
} as any)
const AppDossieRoute = AppDossieRouteImport.update({
  id: '/dossie',
  path: '/dossie',
  getParentRoute: () => AppRoute,
} as any)
const AppEstoqueRoute = AppEstoqueRouteImport.update({
  id: '/estoque',
  path: '/estoque',
  getParentRoute: () => AppRoute,
} as any)
const AppFunilRoute = AppFunilRouteImport.update({
  id: '/funil',
  path: '/funil',
  getParentRoute: () => AppRoute,
} as any)
const AppInicioRoute = AppInicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => AppRoute,
} as any)
const AppMetricasRoute = AppMetricasRouteImport.update({
  id: '/metricas',
  path: '/metricas',
  getParentRoute: () => AppRoute,
} as any)
const AppMinhasFinancasRoute = AppMinhasFinancasRouteImport.update({
  id: '/minhas-financas',
  path: '/minhas-financas',
  getParentRoute: () => AppRoute,
} as any)
const AppMuralRoute = AppMuralRouteImport.update({
  id: '/mural',
  path: '/mural',
  getParentRoute: () => AppRoute,
} as any)
const AppRadarRoute = AppRadarRouteImport.update({
  id: '/radar',
  path: '/radar',
  getParentRoute: () => AppRoute,
} as any)
const AppRetornosRoute = AppRetornosRouteImport.update({
  id: '/retornos',
  path: '/retornos',
  getParentRoute: () => AppRoute,
} as any)
const AppSenhaRoute = AppSenhaRouteImport.update({
  id: '/senha',
  path: '/senha',
  getParentRoute: () => AppRoute,
} as any)
const AppSolicitacoesRoute = AppSolicitacoesRouteImport.update({
  id: '/solicitacoes',
  path: '/solicitacoes',
  getParentRoute: () => AppRoute,
} as any)
const ConfirmarTokenRoute = ConfirmarTokenRouteImport.update({
  id: '/confirmar/$token',
  path: '/confirmar/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAtendimentoIndexRoute = AppAtendimentoIndexRouteImport.update({
  id: '/atendimento/',
  path: '/atendimento/',
  getParentRoute: () => AppRoute,
} as any)
const AppAtendimentoPacienteIdRoute =
  AppAtendimentoPacienteIdRouteImport.update({
    id: '/atendimento/$pacienteId',
    path: '/atendimento/$pacienteId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCirurgiasIndexRoute = AppCirurgiasIndexRouteImport.update({
  id: '/cirurgias/',
  path: '/cirurgias/',
  getParentRoute: () => AppRoute,
} as any)
const AppCirurgiasDitadoRoute = AppCirurgiasDitadoRouteImport.update({
  id: '/cirurgias/ditado',
  path: '/cirurgias/ditado',
  getParentRoute: () => AppRoute,
} as any)
const AppCirurgiasPrecosRoute = AppCirurgiasPrecosRouteImport.update({
  id: '/cirurgias/precos',
  path: '/cirurgias/precos',
  getParentRoute: () => AppRoute,
} as any)
const AppDevSwitchRoute = AppDevSwitchRouteImport.update({
  id: '/dev/switch',
  path: '/dev/switch',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceiroIndexRoute = AppFinanceiroIndexRouteImport.update({
  id: '/financeiro/',
  path: '/financeiro/',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceiroDmedRoute = AppFinanceiroDmedRouteImport.update({
  id: '/financeiro/dmed',
  path: '/financeiro/dmed',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceiroExportarRoute = AppFinanceiroExportarRouteImport.update({
  id: '/financeiro/exportar',
  path: '/financeiro/exportar',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceiroFechamentoRoute = AppFinanceiroFechamentoRouteImport.update({
  id: '/financeiro/fechamento',
  path: '/financeiro/fechamento',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceiroNotasFiscaisRoute =
  AppFinanceiroNotasFiscaisRouteImport.update({
    id: '/financeiro/notas-fiscais',
    path: '/financeiro/notas-fiscais',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrcamentosIndexRoute = AppOrcamentosIndexRouteImport.update({
  id: '/orcamentos/',
  path: '/orcamentos/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrcamentosIdRoute = AppOrcamentosIdRouteImport.update({
  id: '/orcamentos/$id',
  path: '/orcamentos/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPacientesIndexRoute = AppPacientesIndexRouteImport.update({
  id: '/pacientes/',
  path: '/pacientes/',
  getParentRoute: () => AppRoute,
} as any)
const AppAtendimentoAtestadoIdRoute =
  AppAtendimentoAtestadoIdRouteImport.update({
    id: '/atendimento/atestado/$id',
    path: '/atendimento/atestado/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppAtendimentoExameIdRoute = AppAtendimentoExameIdRouteImport.update({
  id: '/atendimento/exame/$id',
  path: '/atendimento/exame/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAtendimentoReceitaIdRoute = AppAtendimentoReceitaIdRouteImport.update({
  id: '/atendimento/receita/$id',
  path: '/atendimento/receita/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppFinanceiroReciboIdRoute = AppFinanceiroReciboIdRouteImport.update({
  id: '/financeiro/recibo/$id',
  path: '/financeiro/recibo/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppPacientesIdIndexRoute = AppPacientesIdIndexRouteImport.update({
  id: '/pacientes/$id/',
  path: '/pacientes/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppPacientesIdExportarRoute = AppPacientesIdExportarRouteImport.update({
  id: '/pacientes/$id/exportar',
  path: '/pacientes/$id/exportar',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/definir-senha': typeof DefinirSenhaRoute
  '/entrar': typeof EntrarRoute
  '/privacidade': typeof PrivacidadeRoute
  '/app/agenda': typeof AppAgendaRoute
  '/app/campanhas': typeof AppCampanhasRoute
  '/app/clinica': typeof AppClinicaRoute
  '/app/comunicacao': typeof AppComunicacaoRoute
  '/app/dossie': typeof AppDossieRoute
  '/app/estoque': typeof AppEstoqueRoute
  '/app/funil': typeof AppFunilRoute
  '/app/inicio': typeof AppInicioRoute
  '/app/metricas': typeof AppMetricasRoute
  '/app/minhas-financas': typeof AppMinhasFinancasRoute
  '/app/mural': typeof AppMuralRoute
  '/app/radar': typeof AppRadarRoute
  '/app/retornos': typeof AppRetornosRoute
  '/app/senha': typeof AppSenhaRoute
  '/app/solicitacoes': typeof AppSolicitacoesRoute
  '/confirmar/$token': typeof ConfirmarTokenRoute
  '/app/': typeof AppIndexRoute
  '/app/atendimento/$pacienteId': typeof AppAtendimentoPacienteIdRoute
  '/app/cirurgias/ditado': typeof AppCirurgiasDitadoRoute
  '/app/cirurgias/precos': typeof AppCirurgiasPrecosRoute
  '/app/dev/switch': typeof AppDevSwitchRoute
  '/app/financeiro/dmed': typeof AppFinanceiroDmedRoute
  '/app/financeiro/exportar': typeof AppFinanceiroExportarRoute
  '/app/financeiro/fechamento': typeof AppFinanceiroFechamentoRoute
  '/app/financeiro/notas-fiscais': typeof AppFinanceiroNotasFiscaisRoute
  '/app/orcamentos/$id': typeof AppOrcamentosIdRoute
  '/app/atendimento/': typeof AppAtendimentoIndexRoute
  '/app/cirurgias/': typeof AppCirurgiasIndexRoute
  '/app/financeiro/': typeof AppFinanceiroIndexRoute
  '/app/orcamentos/': typeof AppOrcamentosIndexRoute
  '/app/pacientes/': typeof AppPacientesIndexRoute
  '/app/atendimento/atestado/$id': typeof AppAtendimentoAtestadoIdRoute
  '/app/atendimento/exame/$id': typeof AppAtendimentoExameIdRoute
  '/app/atendimento/receita/$id': typeof AppAtendimentoReceitaIdRoute
  '/app/financeiro/recibo/$id': typeof AppFinanceiroReciboIdRoute
  '/app/pacientes/$id/exportar': typeof AppPacientesIdExportarRoute
  '/app/pacientes/$id/': typeof AppPacientesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/definir-senha': typeof DefinirSenhaRoute
  '/entrar': typeof EntrarRoute
  '/privacidade': typeof PrivacidadeRoute
  '/app/agenda': typeof AppAgendaRoute
  '/app/campanhas': typeof AppCampanhasRoute
  '/app/clinica': typeof AppClinicaRoute
  '/app/comunicacao': typeof AppComunicacaoRoute
  '/app/dossie': typeof AppDossieRoute
  '/app/estoque': typeof AppEstoqueRoute
  '/app/funil': typeof AppFunilRoute
  '/app/inicio': typeof AppInicioRoute
  '/app/metricas': typeof AppMetricasRoute
  '/app/minhas-financas': typeof AppMinhasFinancasRoute
  '/app/mural': typeof AppMuralRoute
  '/app/radar': typeof AppRadarRoute
  '/app/retornos': typeof AppRetornosRoute
  '/app/senha': typeof AppSenhaRoute
  '/app/solicitacoes': typeof AppSolicitacoesRoute
  '/confirmar/$token': typeof ConfirmarTokenRoute
  '/app': typeof AppIndexRoute
  '/app/atendimento/$pacienteId': typeof AppAtendimentoPacienteIdRoute
  '/app/cirurgias/ditado': typeof AppCirurgiasDitadoRoute
  '/app/cirurgias/precos': typeof AppCirurgiasPrecosRoute
  '/app/dev/switch': typeof AppDevSwitchRoute
  '/app/financeiro/dmed': typeof AppFinanceiroDmedRoute
  '/app/financeiro/exportar': typeof AppFinanceiroExportarRoute
  '/app/financeiro/fechamento': typeof AppFinanceiroFechamentoRoute
  '/app/financeiro/notas-fiscais': typeof AppFinanceiroNotasFiscaisRoute
  '/app/orcamentos/$id': typeof AppOrcamentosIdRoute
  '/app/atendimento': typeof AppAtendimentoIndexRoute
  '/app/cirurgias': typeof AppCirurgiasIndexRoute
  '/app/financeiro': typeof AppFinanceiroIndexRoute
  '/app/orcamentos': typeof AppOrcamentosIndexRoute
  '/app/pacientes': typeof AppPacientesIndexRoute
  '/app/atendimento/atestado/$id': typeof AppAtendimentoAtestadoIdRoute
  '/app/atendimento/exame/$id': typeof AppAtendimentoExameIdRoute
  '/app/atendimento/receita/$id': typeof AppAtendimentoReceitaIdRoute
  '/app/financeiro/recibo/$id': typeof AppFinanceiroReciboIdRoute
  '/app/pacientes/$id/exportar': typeof AppPacientesIdExportarRoute
  '/app/pacientes/$id': typeof AppPacientesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/definir-senha': typeof DefinirSenhaRoute
  '/entrar': typeof EntrarRoute
  '/privacidade': typeof PrivacidadeRoute
  '/app/agenda': typeof AppAgendaRoute
  '/app/campanhas': typeof AppCampanhasRoute
  '/app/clinica': typeof AppClinicaRoute
  '/app/comunicacao': typeof AppComunicacaoRoute
  '/app/dossie': typeof AppDossieRoute
  '/app/estoque': typeof AppEstoqueRoute
  '/app/funil': typeof AppFunilRoute
  '/app/inicio': typeof AppInicioRoute
  '/app/metricas': typeof AppMetricasRoute
  '/app/minhas-financas': typeof AppMinhasFinancasRoute
  '/app/mural': typeof AppMuralRoute
  '/app/radar': typeof AppRadarRoute
  '/app/retornos': typeof AppRetornosRoute
  '/app/senha': typeof AppSenhaRoute
  '/app/solicitacoes': typeof AppSolicitacoesRoute
  '/confirmar/$token': typeof ConfirmarTokenRoute
  '/app/': typeof AppIndexRoute
  '/app/atendimento/$pacienteId': typeof AppAtendimentoPacienteIdRoute
  '/app/cirurgias/ditado': typeof AppCirurgiasDitadoRoute
  '/app/cirurgias/precos': typeof AppCirurgiasPrecosRoute
  '/app/dev/switch': typeof AppDevSwitchRoute
  '/app/financeiro/dmed': typeof AppFinanceiroDmedRoute
  '/app/financeiro/exportar': typeof AppFinanceiroExportarRoute
  '/app/financeiro/fechamento': typeof AppFinanceiroFechamentoRoute
  '/app/financeiro/notas-fiscais': typeof AppFinanceiroNotasFiscaisRoute
  '/app/orcamentos/$id': typeof AppOrcamentosIdRoute
  '/app/atendimento/': typeof AppAtendimentoIndexRoute
  '/app/cirurgias/': typeof AppCirurgiasIndexRoute
  '/app/financeiro/': typeof AppFinanceiroIndexRoute
  '/app/orcamentos/': typeof AppOrcamentosIndexRoute
  '/app/pacientes/': typeof AppPacientesIndexRoute
  '/app/atendimento/atestado/$id': typeof AppAtendimentoAtestadoIdRoute
  '/app/atendimento/exame/$id': typeof AppAtendimentoExameIdRoute
  '/app/atendimento/receita/$id': typeof AppAtendimentoReceitaIdRoute
  '/app/financeiro/recibo/$id': typeof AppFinanceiroReciboIdRoute
  '/app/pacientes/$id/exportar': typeof AppPacientesIdExportarRoute
  '/app/pacientes/$id/': typeof AppPacientesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/definir-senha'
    | '/entrar'
    | '/privacidade'
    | '/app/agenda'
    | '/app/campanhas'
    | '/app/clinica'
    | '/app/comunicacao'
    | '/app/dossie'
    | '/app/estoque'
    | '/app/funil'
    | '/app/inicio'
    | '/app/metricas'
    | '/app/minhas-financas'
    | '/app/mural'
    | '/app/radar'
    | '/app/retornos'
    | '/app/senha'
    | '/app/solicitacoes'
    | '/confirmar/$token'
    | '/app/'
    | '/app/atendimento/$pacienteId'
    | '/app/cirurgias/ditado'
    | '/app/cirurgias/precos'
    | '/app/dev/switch'
    | '/app/financeiro/dmed'
    | '/app/financeiro/exportar'
    | '/app/financeiro/fechamento'
    | '/app/financeiro/notas-fiscais'
    | '/app/orcamentos/$id'
    | '/app/atendimento/'
    | '/app/cirurgias/'
    | '/app/financeiro/'
    | '/app/orcamentos/'
    | '/app/pacientes/'
    | '/app/atendimento/atestado/$id'
    | '/app/atendimento/exame/$id'
    | '/app/atendimento/receita/$id'
    | '/app/financeiro/recibo/$id'
    | '/app/pacientes/$id/exportar'
    | '/app/pacientes/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/definir-senha'
    | '/entrar'
    | '/privacidade'
    | '/app/agenda'
    | '/app/campanhas'
    | '/app/clinica'
    | '/app/comunicacao'
    | '/app/dossie'
    | '/app/estoque'
    | '/app/funil'
    | '/app/inicio'
    | '/app/metricas'
    | '/app/minhas-financas'
    | '/app/mural'
    | '/app/radar'
    | '/app/retornos'
    | '/app/senha'
    | '/app/solicitacoes'
    | '/confirmar/$token'
    | '/app'
    | '/app/atendimento/$pacienteId'
    | '/app/cirurgias/ditado'
    | '/app/cirurgias/precos'
    | '/app/dev/switch'
    | '/app/financeiro/dmed'
    | '/app/financeiro/exportar'
    | '/app/financeiro/fechamento'
    | '/app/financeiro/notas-fiscais'
    | '/app/orcamentos/$id'
    | '/app/atendimento'
    | '/app/cirurgias'
    | '/app/financeiro'
    | '/app/orcamentos'
    | '/app/pacientes'
    | '/app/atendimento/atestado/$id'
    | '/app/atendimento/exame/$id'
    | '/app/atendimento/receita/$id'
    | '/app/financeiro/recibo/$id'
    | '/app/pacientes/$id/exportar'
    | '/app/pacientes/$id'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/definir-senha'
    | '/entrar'
    | '/privacidade'
    | '/app/agenda'
    | '/app/campanhas'
    | '/app/clinica'
    | '/app/comunicacao'
    | '/app/dossie'
    | '/app/estoque'
    | '/app/funil'
    | '/app/inicio'
    | '/app/metricas'
    | '/app/minhas-financas'
    | '/app/mural'
    | '/app/radar'
    | '/app/retornos'
    | '/app/senha'
    | '/app/solicitacoes'
    | '/confirmar/$token'
    | '/app/'
    | '/app/atendimento/$pacienteId'
    | '/app/cirurgias/ditado'
    | '/app/cirurgias/precos'
    | '/app/dev/switch'
    | '/app/financeiro/dmed'
    | '/app/financeiro/exportar'
    | '/app/financeiro/fechamento'
    | '/app/financeiro/notas-fiscais'
    | '/app/orcamentos/$id'
    | '/app/atendimento/'
    | '/app/cirurgias/'
    | '/app/financeiro/'
    | '/app/orcamentos/'
    | '/app/pacientes/'
    | '/app/atendimento/atestado/$id'
    | '/app/atendimento/exame/$id'
    | '/app/atendimento/receita/$id'
    | '/app/financeiro/recibo/$id'
    | '/app/pacientes/$id/exportar'
    | '/app/pacientes/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  DefinirSenhaRoute: typeof DefinirSenhaRoute
  EntrarRoute: typeof EntrarRoute
  PrivacidadeRoute: typeof PrivacidadeRoute
  ConfirmarTokenRoute: typeof ConfirmarTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/definir-senha': {
      id: '/definir-senha'
      path: '/definir-senha'
      fullPath: '/definir-senha'
      preLoaderRoute: typeof DefinirSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/agenda': {
      id: '/app/agenda'
      path: '/agenda'
      fullPath: '/app/agenda'
      preLoaderRoute: typeof AppAgendaRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/campanhas': {
      id: '/app/campanhas'
      path: '/campanhas'
      fullPath: '/app/campanhas'
      preLoaderRoute: typeof AppCampanhasRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/clinica': {
      id: '/app/clinica'
      path: '/clinica'
      fullPath: '/app/clinica'
      preLoaderRoute: typeof AppClinicaRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/comunicacao': {
      id: '/app/comunicacao'
      path: '/comunicacao'
      fullPath: '/app/comunicacao'
      preLoaderRoute: typeof AppComunicacaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dossie': {
      id: '/app/dossie'
      path: '/dossie'
      fullPath: '/app/dossie'
      preLoaderRoute: typeof AppDossieRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/estoque': {
      id: '/app/estoque'
      path: '/estoque'
      fullPath: '/app/estoque'
      preLoaderRoute: typeof AppEstoqueRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/funil': {
      id: '/app/funil'
      path: '/funil'
      fullPath: '/app/funil'
      preLoaderRoute: typeof AppFunilRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/inicio': {
      id: '/app/inicio'
      path: '/inicio'
      fullPath: '/app/inicio'
      preLoaderRoute: typeof AppInicioRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/metricas': {
      id: '/app/metricas'
      path: '/metricas'
      fullPath: '/app/metricas'
      preLoaderRoute: typeof AppMetricasRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/minhas-financas': {
      id: '/app/minhas-financas'
      path: '/minhas-financas'
      fullPath: '/app/minhas-financas'
      preLoaderRoute: typeof AppMinhasFinancasRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/mural': {
      id: '/app/mural'
      path: '/mural'
      fullPath: '/app/mural'
      preLoaderRoute: typeof AppMuralRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/radar': {
      id: '/app/radar'
      path: '/radar'
      fullPath: '/app/radar'
      preLoaderRoute: typeof AppRadarRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/retornos': {
      id: '/app/retornos'
      path: '/retornos'
      fullPath: '/app/retornos'
      preLoaderRoute: typeof AppRetornosRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/senha': {
      id: '/app/senha'
      path: '/senha'
      fullPath: '/app/senha'
      preLoaderRoute: typeof AppSenhaRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/solicitacoes': {
      id: '/app/solicitacoes'
      path: '/solicitacoes'
      fullPath: '/app/solicitacoes'
      preLoaderRoute: typeof AppSolicitacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/confirmar/$token': {
      id: '/confirmar/$token'
      path: '/confirmar/$token'
      fullPath: '/confirmar/$token'
      preLoaderRoute: typeof ConfirmarTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/atendimento/': {
      id: '/app/atendimento/'
      path: '/atendimento'
      fullPath: '/app/atendimento/'
      preLoaderRoute: typeof AppAtendimentoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/atendimento/$pacienteId': {
      id: '/app/atendimento/$pacienteId'
      path: '/atendimento/$pacienteId'
      fullPath: '/app/atendimento/$pacienteId'
      preLoaderRoute: typeof AppAtendimentoPacienteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/cirurgias/': {
      id: '/app/cirurgias/'
      path: '/cirurgias'
      fullPath: '/app/cirurgias/'
      preLoaderRoute: typeof AppCirurgiasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/cirurgias/ditado': {
      id: '/app/cirurgias/ditado'
      path: '/cirurgias/ditado'
      fullPath: '/app/cirurgias/ditado'
      preLoaderRoute: typeof AppCirurgiasDitadoRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/cirurgias/precos': {
      id: '/app/cirurgias/precos'
      path: '/cirurgias/precos'
      fullPath: '/app/cirurgias/precos'
      preLoaderRoute: typeof AppCirurgiasPrecosRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/dev/switch': {
      id: '/app/dev/switch'
      path: '/dev/switch'
      fullPath: '/app/dev/switch'
      preLoaderRoute: typeof AppDevSwitchRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/financeiro/': {
      id: '/app/financeiro/'
      path: '/financeiro'
      fullPath: '/app/financeiro/'
      preLoaderRoute: typeof AppFinanceiroIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/financeiro/dmed': {
      id: '/app/financeiro/dmed'
      path: '/financeiro/dmed'
      fullPath: '/app/financeiro/dmed'
      preLoaderRoute: typeof AppFinanceiroDmedRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/financeiro/exportar': {
      id: '/app/financeiro/exportar'
      path: '/financeiro/exportar'
      fullPath: '/app/financeiro/exportar'
      preLoaderRoute: typeof AppFinanceiroExportarRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/financeiro/fechamento': {
      id: '/app/financeiro/fechamento'
      path: '/financeiro/fechamento'
      fullPath: '/app/financeiro/fechamento'
      preLoaderRoute: typeof AppFinanceiroFechamentoRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/financeiro/notas-fiscais': {
      id: '/app/financeiro/notas-fiscais'
      path: '/financeiro/notas-fiscais'
      fullPath: '/app/financeiro/notas-fiscais'
      preLoaderRoute: typeof AppFinanceiroNotasFiscaisRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/orcamentos/': {
      id: '/app/orcamentos/'
      path: '/orcamentos'
      fullPath: '/app/orcamentos/'
      preLoaderRoute: typeof AppOrcamentosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/orcamentos/$id': {
      id: '/app/orcamentos/$id'
      path: '/orcamentos/$id'
      fullPath: '/app/orcamentos/$id'
      preLoaderRoute: typeof AppOrcamentosIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/pacientes/': {
      id: '/app/pacientes/'
      path: '/pacientes'
      fullPath: '/app/pacientes/'
      preLoaderRoute: typeof AppPacientesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/atendimento/atestado/$id': {
      id: '/app/atendimento/atestado/$id'
      path: '/atendimento/atestado/$id'
      fullPath: '/app/atendimento/atestado/$id'
      preLoaderRoute: typeof AppAtendimentoAtestadoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/atendimento/exame/$id': {
      id: '/app/atendimento/exame/$id'
      path: '/atendimento/exame/$id'
      fullPath: '/app/atendimento/exame/$id'
      preLoaderRoute: typeof AppAtendimentoExameIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/atendimento/receita/$id': {
      id: '/app/atendimento/receita/$id'
      path: '/atendimento/receita/$id'
      fullPath: '/app/atendimento/receita/$id'
      preLoaderRoute: typeof AppAtendimentoReceitaIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/financeiro/recibo/$id': {
      id: '/app/financeiro/recibo/$id'
      path: '/financeiro/recibo/$id'
      fullPath: '/app/financeiro/recibo/$id'
      preLoaderRoute: typeof AppFinanceiroReciboIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/pacientes/$id/': {
      id: '/app/pacientes/$id/'
      path: '/pacientes/$id'
      fullPath: '/app/pacientes/$id/'
      preLoaderRoute: typeof AppPacientesIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/pacientes/$id/exportar': {
      id: '/app/pacientes/$id/exportar'
      path: '/pacientes/$id/exportar'
      fullPath: '/app/pacientes/$id/exportar'
      preLoaderRoute: typeof AppPacientesIdExportarRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAgendaRoute: typeof AppAgendaRoute
  AppCampanhasRoute: typeof AppCampanhasRoute
  AppClinicaRoute: typeof AppClinicaRoute
  AppComunicacaoRoute: typeof AppComunicacaoRoute
  AppDossieRoute: typeof AppDossieRoute
  AppEstoqueRoute: typeof AppEstoqueRoute
  AppFunilRoute: typeof AppFunilRoute
  AppInicioRoute: typeof AppInicioRoute
  AppMetricasRoute: typeof AppMetricasRoute
  AppMinhasFinancasRoute: typeof AppMinhasFinancasRoute
  AppMuralRoute: typeof AppMuralRoute
  AppRadarRoute: typeof AppRadarRoute
  AppRetornosRoute: typeof AppRetornosRoute
  AppSenhaRoute: typeof AppSenhaRoute
  AppSolicitacoesRoute: typeof AppSolicitacoesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAtendimentoPacienteIdRoute: typeof AppAtendimentoPacienteIdRoute
  AppCirurgiasDitadoRoute: typeof AppCirurgiasDitadoRoute
  AppCirurgiasPrecosRoute: typeof AppCirurgiasPrecosRoute
  AppDevSwitchRoute: typeof AppDevSwitchRoute
  AppFinanceiroDmedRoute: typeof AppFinanceiroDmedRoute
  AppFinanceiroExportarRoute: typeof AppFinanceiroExportarRoute
  AppFinanceiroFechamentoRoute: typeof AppFinanceiroFechamentoRoute
  AppFinanceiroNotasFiscaisRoute: typeof AppFinanceiroNotasFiscaisRoute
  AppOrcamentosIdRoute: typeof AppOrcamentosIdRoute
  AppAtendimentoIndexRoute: typeof AppAtendimentoIndexRoute
  AppCirurgiasIndexRoute: typeof AppCirurgiasIndexRoute
  AppFinanceiroIndexRoute: typeof AppFinanceiroIndexRoute
  AppOrcamentosIndexRoute: typeof AppOrcamentosIndexRoute
  AppPacientesIndexRoute: typeof AppPacientesIndexRoute
  AppAtendimentoAtestadoIdRoute: typeof AppAtendimentoAtestadoIdRoute
  AppAtendimentoExameIdRoute: typeof AppAtendimentoExameIdRoute
  AppAtendimentoReceitaIdRoute: typeof AppAtendimentoReceitaIdRoute
  AppFinanceiroReciboIdRoute: typeof AppFinanceiroReciboIdRoute
  AppPacientesIdExportarRoute: typeof AppPacientesIdExportarRoute
  AppPacientesIdIndexRoute: typeof AppPacientesIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAgendaRoute: AppAgendaRoute,
  AppCampanhasRoute: AppCampanhasRoute,
  AppClinicaRoute: AppClinicaRoute,
  AppComunicacaoRoute: AppComunicacaoRoute,
  AppDossieRoute: AppDossieRoute,
  AppEstoqueRoute: AppEstoqueRoute,
  AppFunilRoute: AppFunilRoute,
  AppInicioRoute: AppInicioRoute,
  AppMetricasRoute: AppMetricasRoute,
  AppMinhasFinancasRoute: AppMinhasFinancasRoute,
  AppMuralRoute: AppMuralRoute,
  AppRadarRoute: AppRadarRoute,
  AppRetornosRoute: AppRetornosRoute,
  AppSenhaRoute: AppSenhaRoute,
  AppSolicitacoesRoute: AppSolicitacoesRoute,
  AppIndexRoute: AppIndexRoute,
  AppAtendimentoPacienteIdRoute: AppAtendimentoPacienteIdRoute,
  AppCirurgiasDitadoRoute: AppCirurgiasDitadoRoute,
  AppCirurgiasPrecosRoute: AppCirurgiasPrecosRoute,
  AppDevSwitchRoute: AppDevSwitchRoute,
  AppFinanceiroDmedRoute: AppFinanceiroDmedRoute,
  AppFinanceiroExportarRoute: AppFinanceiroExportarRoute,
  AppFinanceiroFechamentoRoute: AppFinanceiroFechamentoRoute,
  AppFinanceiroNotasFiscaisRoute: AppFinanceiroNotasFiscaisRoute,
  AppOrcamentosIdRoute: AppOrcamentosIdRoute,
  AppAtendimentoIndexRoute: AppAtendimentoIndexRoute,
  AppCirurgiasIndexRoute: AppCirurgiasIndexRoute,
  AppFinanceiroIndexRoute: AppFinanceiroIndexRoute,
  AppOrcamentosIndexRoute: AppOrcamentosIndexRoute,
  AppPacientesIndexRoute: AppPacientesIndexRoute,
  AppAtendimentoAtestadoIdRoute: AppAtendimentoAtestadoIdRoute,
  AppAtendimentoExameIdRoute: AppAtendimentoExameIdRoute,
  AppAtendimentoReceitaIdRoute: AppAtendimentoReceitaIdRoute,
  AppFinanceiroReciboIdRoute: AppFinanceiroReciboIdRoute,
  AppPacientesIdExportarRoute: AppPacientesIdExportarRoute,
  AppPacientesIdIndexRoute: AppPacientesIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  DefinirSenhaRoute: DefinirSenhaRoute,
  EntrarRoute: EntrarRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  ConfirmarTokenRoute: ConfirmarTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
